import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

const GlobalStyles = createGlobalStyle`
    ${reset}

    @font-face {
        font-family: 'Pretendard';
        src: url('/assets/font/Pretendard-ExtraLight.otf') format('opentype');
        font-weight: 200;
    }

    @font-face {
        font-family: 'Pretendard';
        src: url('/assets/font/Pretendard-Regular.otf') format('opentype');
        font-weight: 400;
    }

    @font-face {
        font-family: 'Pretendard';
        src: url('/assets/font/Pretendard-Medium.otf') format('opentype');
        font-weight: 500;
    }

    @font-face {
        font-family: 'Pretendard';
        src: url('/assets/font/Pretendard-Bold.otf') format('opentype');
        font-weight: 700;
    }


	* {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
        Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }
    
    body {
        font-weight: 400;
        font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
        Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }

    button {
        border: none;
        cursor: pointer;

    }

    ul > li {
        list-style: none;
    }

    /* ::-webkit-scrollbar {
        display: none;
    } */
`;

export default GlobalStyles;
